export default __webpack_public_path__ + "static/media/mini_akamai.10e0eb21.svg";